import { IApplicationState } from '../../types/redux';

export function getReviewsCount(state: IApplicationState) {
  return state.objectInfo.reviewsCount;
}
